import { render, staticRenderFns } from "./GastroVisitaProctologicaView.vue?vue&type=template&id=f86e4202"
import script from "./GastroVisitaProctologicaView.vue?vue&type=script&lang=js"
export * from "./GastroVisitaProctologicaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports